import React from "react";

export default function Credit() {
  return (
    <div class="credit">
    <p>
      Coded by
      <a href="https://tsfolio.com/"> Takahiro Sasaki</a>,  <a href="https://github.com/TKssk01"> Github.</a> Hosted on Netlify
    </p>
  </div>
  );
}